import React from 'react'
import { Redirect } from 'react-router-dom'
import ExaminerContainer from '../ExaminerContainer'
import ExaminerConfigurationsList from './ExaminerConfigurationsList'
import { isLoggedIn } from '../../../api'
import { examinerHasRole } from '../../../components/RoleAccess'

export default function ExaminerConfigurationsPage() {
    if (!isLoggedIn('examiner')) {
        return <Redirect to="/login" />
    }

    if (!examinerHasRole(['admin', 'superuser'])) {
        return <Redirect to="/examiner" />
    }

    return (
        <ExaminerContainer heading="Configurations">
            <ExaminerConfigurationsList />
        </ExaminerContainer>
    )
}
